import { render, staticRenderFns } from "./ServiceProfit.vue?vue&type=template&id=b15655ee&scoped=true"
import script from "./ServiceProfit.vue?vue&type=script&lang=js"
export * from "./ServiceProfit.vue?vue&type=script&lang=js"
import style0 from "./ServiceProfit.vue?vue&type=style&index=0&id=b15655ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15655ee",
  null
  
)

export default component.exports